<div class="modalReject">
  <div class="container-modal">
    <div class="box-title">
      <div class="m-3">
        <span class="copec-bold-20">{{ title }}</span>
      </div>
      <div class="box-button">
        <button
          type="button"
          class="close pull-right closeModalIcon"
          (click)="closeModal()"
          aria-label="Close"
        >
          <span class="button-close" aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <div class="icon-box">
      <img class="search-icon-image" src="/assets/icono/reject-status.svg" alt="" />
    </div>
    <div class="body-modal">
      <span class="copec-rg-16">Motivo de rechazo: </span>
      <mat-form-field appearance="fill">
        <mat-label>Opciones</mat-label>
        <mat-select
          [(value)]="selectedOption"
          [formControl]="rejectOption"
          required
        >
          <mat-option *ngFor="let option of options" [value]="option.code">
            {{ option.description }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="rejectOption.hasError('required')"
          >Selecciona una opción
        </mat-error>
      </mat-form-field>
    </div>
    <div class="button-options">
      <button
        mat-dialog-close
        class="button-cancel-box copec-rg-16"
        (click)="closeModal()"
      >
        Cancelar
      </button>
      <button
        mat-dialog-close
        cdkFocusInitial
        class="button-reject-box copec-rg-16"
        (click)="rejectRequest()"
      >
        Rechazar solicitud
      </button>
    </div>
  </div>
</div>
